import React from 'react';

function IntroText() {
  return (
    <div className="intro-text">
      <h1>On May 21st, 2014 I bought the domain FartorArt.com.</h1>
    	<h2>I thought it would be funny.</h2>
    	<p>Unfortunately, I've now been paying for this domain for five years and I've never really known what to do with it. To be honest, this isn't even really my type of joke.</p>
    	<h3>So, how about you, got any ideas?</h3>
    </div>
  );
}

export default IntroText;
